import React from "react";
import "./Policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: March 2026</p>

        <p>
          At <strong>Zynvert Technologies</strong>, we respect your privacy and are committed 
          to protecting your personal information. This Privacy Policy explains how we 
          collect, use, and safeguard your information when you visit or make a purchase 
          from <strong>www.zynvert.com</strong>.
        </p>

        <h2>1. Information We Collect</h2>

        <p>When you use our website, we may collect the following types of information:</p>

        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Billing and shipping address</li>
          <li>Order and purchase details</li>
          <li>Payment transaction data</li>
          <li>Device and browser information</li>
          <li>IP address and approximate location</li>
        </ul>

        <h2>2. How We Use Your Information</h2>

        <p>Your information may be used for the following purposes:</p>

        <ul>
          <li>Processing and delivering your orders</li>
          <li>Providing customer support and responding to inquiries</li>
          <li>Sending order confirmations, updates, and invoices</li>
          <li>Improving website functionality and user experience</li>
          <li>Detecting and preventing fraud or unauthorized activity</li>
          <li>Sending marketing and promotional communications (optional)</li>
        </ul>

        <h2>3. Payment Security</h2>

        <p>
          All payments are processed through secure third-party payment gateways. 
          We do <strong>not store your card details or banking information</strong> 
          on our servers.
        </p>

        <h2>4. Cookies & Tracking Technologies</h2>

        <p>
          Our website uses cookies and similar technologies to enhance user experience, 
          analyze traffic, and improve website performance.
        </p>

        <h2>5. Data Protection</h2>

        <p>
          We implement industry-standard security practices to protect your personal 
          information from unauthorized access, disclosure, or misuse.
        </p>

        <h2>6. Third-Party Services</h2>

        <p>
          We may share necessary information with trusted third-party partners such as:
        </p>

        <ul>
          <li>Payment gateway providers</li>
          <li>Shipping and logistics companies</li>
          <li>Analytics services</li>
        </ul>

        <h2>7. Your Rights</h2>

        <p>You have the right to:</p>

        <ul>
          <li>Request access to your personal data</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your personal data</li>
        </ul>

        <h2>8. Children's Privacy</h2>

        <p>
          Our website is not intended for children under the age of 13. We do not 
          knowingly collect personal information from children.
        </p>

        <h2>9. Updates to This Policy</h2>

        <p>
          We may update this Privacy Policy from time to time. Any changes will be 
          posted on this page with an updated revision date.
        </p>

        <h2>10. Contact Us</h2>

        <p>If you have any questions regarding this Privacy Policy, you can contact us:</p>

        <p>
          <strong>Email:</strong> support@zynvert.com
        </p>

        <p>
          <strong>Address:</strong><br />
          Debolina Apartment, Flat No-101<br />
          Ground Floor, Kolkata – 700059<br />
          West Bengal, India
        </p>

      </div>
    </div>
  );
};

export default PrivacyPolicy;